module.exports = __webpack_public_path__ + "static/media/delivered-icon.2b9909a3.svg";